namespace Gordic.Uda.WebControls {
    let gcontent = Decorators.gcontent;

    /**
     * Všeobecné testy
     *
     * @author Jindřich Vácha
     * @since 480.2.0.0
     */
    @gcontent
    export class ObecneTesty extends GContentBase {

        taskId = "actObecneTesty";

        /**
         * model (definovane jako ContentValues)
         * @type {Gordic.Uda.WebControls.ObecneTestyDto}
         */
        protected model: Gordic.Uda.WebControls.ObecneTestyDto;

        /**
         * model (definovane jako ContentValues)
         * @type {Gordic.Uda.WebControls.ObecneTestyDto}
         */
        protected jsonProp?: Gordic.Uda.WebControls.ObecneTestyDto;

        /**
         * Definice formuláře
         */
        public onContentReady(): void {

            let that = this;

            console.log("Gordic.Uda.WebControls.ObecneTesty.onContentReady", this);

            // akce seznamu
            this.actions.addRange({
                //-----------------------------------------------------------------------------------------------------
                // Vyvěšení
                actVyveseni1: {
                    name: "actVyveseni1",
                    caption: "Vyvěšení (nothing+bez ixb, názvu a popisu)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        that.otevriVyveseni(undefined);
                    }
                },
                actVyveseni2: {
                    name: "actVyveseni2",
                    caption: "Vyvěšení (auto)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        that.otevriVyveseni(Gordic.Gin.Globals.Enums.ModOtevreni.auto);
                    }
                    //run: function (ev, ctx) {
                    //    Gordic.Uda.Dialogs.VyveseniNaUredniDesku(
                    //        that
                    //        , { Ixp: "DEMOX0015BBE", Ixb: "", Nazev: "Vyvěšení (auto)", Popis: "" }
                    //        , Gordic.Gin.Globals.Enums.ModOtevreni.auto
                    //    );
                    //}
                },
                actVyveseni3: {
                    name: "actVyveseni3",
                    caption: "Vyvěšení (navigate)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        that.otevriVyveseni(Gordic.Gin.Globals.Enums.ModOtevreni.navigate);
                    }
                    //run: function (ev, ctx) {
                    //    Gordic.Uda.Dialogs.VyveseniNaUredniDesku(
                    //        that
                    //        , { Ixp: "DEMOX0015BBE", Ixb: "", Nazev: "Vyvěšení (navigate)", Popis: "" }
                    //        , Gordic.Gin.Globals.Enums.ModOtevreni.navigate
                    //    );
                    //}
                },
                actVyveseni4: {
                    name: "actVyveseni4",
                    caption: "Vyvěšení (navigateTask)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        that.otevriVyveseni(Gordic.Gin.Globals.Enums.ModOtevreni.navigateTask);
                    }
                    //run: function (ev, ctx) {
                    //    Gordic.Uda.Dialogs.VyveseniNaUredniDesku(
                    //        that
                    //        , { Ixp: "DEMOX0015BBE", Ixb: "", Nazev: "Vyvěšení (navigateTask)", Popis: "" }
                    //        , Gordic.Gin.Globals.Enums.ModOtevreni.navigateTask
                    //    );
                    //}
                },
                actVyveseni5: {
                    name: "actVyveseni5",
                    caption: "Vyvěšení (showModalWindow)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        that.otevriVyveseni(Gordic.Gin.Globals.Enums.ModOtevreni.showModalWindow);
                    }
                    //run: function (ev, ctx) {
                    //    Gordic.Uda.Dialogs.VyveseniNaUredniDesku(
                    //        that
                    //        , { Ixp: "DEMOX0015BBE", Ixb: "", Nazev: "Vyvěšení (showModalWindow)", Popis: "" }
                    //        , Gordic.Gin.Globals.Enums.ModOtevreni.showModalWindow
                    //    );
                    //}
                },
                actVyveseni6: {
                    name: "actVyveseni6",
                    caption: "Vyvěšení (showWindow)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        that.otevriVyveseni(Gordic.Gin.Globals.Enums.ModOtevreni.showWindow);
                    }
                    //run: function (ev, ctx) {
                    //    Gordic.Uda.Dialogs.VyveseniNaUredniDesku(
                    //        that
                    //        , { Ixp: "DEMOX0015BBE", Ixb: "", Nazev: "Vyvěšení (showWindow)", Popis: "" }
                    //        , Gordic.Gin.Globals.Enums.ModOtevreni.showWindow
                    //    );
                    //}
                },
                //-----------------------------------------------------------------------------------------------------
                // Zveřejnění
                actZverejneni1: {
                    name: "actZverejneni1",
                    caption: "Zveřejnění (nothing + bez ixp, názvu a popisu)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboru(
                            that
                            , { Ixb: "DEMO0C011DM6" }
                            //,Gordic.Gin.Globals.Enums.ModOtevreni.showModalWindow
                        );
                    }
                },
                actZverejneni2: {
                    name: "actZverejneni2",
                    caption: "Zveřejnění (auto)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboru(
                            that
                            , { Ixb: "DEMO0C011DM6", Ixp: "", Nazev: "Zveřejnění (auto)", Popis: "" }
                            , Gordic.Gin.Globals.Enums.ModOtevreni.auto
                        );
                    }
                },
                actZverejneni3: {
                    name: "actZverejneni3",
                    caption: "Zveřejnění (navigate)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboru(
                            that
                            , { Ixb: "DEMO0C011DM6", Ixp: "", Nazev: "Zveřejnění (navigate)", Popis: "" }
                            , Gordic.Gin.Globals.Enums.ModOtevreni.navigate
                        );
                    }
                },
                actZverejneni4: {
                    name: "actZverejneni4",
                    caption: "Zveřejnění (navigateTask)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboru(
                            that
                            , { Ixb: "DEMO0C011DM6", Ixp: "", Nazev: "Zveřejnění (navigateTask)", Popis: "" }
                            , Gordic.Gin.Globals.Enums.ModOtevreni.navigateTask
                        );
                    }
                },
                actZverejneni5: {
                    name: "actZverejneni5",
                    caption: "Zveřejnění (showModalWindow)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboru(
                            that
                            , { Ixb: "DEMO0C011DM6", Ixp: "", Nazev: "Zveřejnění (showModalWindow)", Popis: "" }
                            , Gordic.Gin.Globals.Enums.ModOtevreni.showModalWindow
                        );
                    }
                },
                actZverejneni6: {
                    name: "actZverejneni6",
                    caption: "Zveřejnění (showWindow)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboru(
                            that
                            , { Ixb: "DEMO0C011DM6", Ixp: "", Nazev: "Zveřejnění (showWindow)", Popis: "" }
                            , Gordic.Gin.Globals.Enums.ModOtevreni.showWindow
                        );
                    }
                },
                //-----------------------------------------------------------------------------------------------------
                // ZverejneniSouboruHistorie
                actZverejneniHistorie1: {
                    name: "actZverejneniHistorie1",
                    caption: "Zveřejnění (nothing)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboruHistorie(
                            that
                            , { Ixb: "DEMO0C011DM6" }
                            //,Gordic.Gin.Globals.Enums.ModOtevreni.showModalWindow
                        );
                    }
                },
                actZverejneniHistorie2: {
                    name: "actZverejneniHistorie2",
                    caption: "Zveřejnění (auto)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboruHistorie(
                            that
                            , { Ixb: "DEMO0C011DM6" }
                            , Gordic.Gin.Globals.Enums.ModOtevreni.auto
                        );
                    }
                },
                actZverejneniHistorie3: {
                    name: "actZverejneniHistorie3",
                    caption: "Zveřejnění (navigate)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboruHistorie(
                            that
                            , { Ixb: "DEMO0C011DM6" }
                            , Gordic.Gin.Globals.Enums.ModOtevreni.navigate
                        );
                    }
                },
                actZverejneniHistorie4: {
                    name: "actZverejneniHistorie4",
                    caption: "Zveřejnění (navigateTask)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboruHistorie(
                            that
                            , { Ixb: "DEMO0C011DM6" }
                            , Gordic.Gin.Globals.Enums.ModOtevreni.navigateTask
                        );
                    }
                },
                actZverejneniHistorie5: {
                    name: "actZverejneniHistorie5",
                    caption: "Zveřejnění (showModalWindow)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboruHistorie(
                            that
                            , { Ixb: "DEMO0C011DM6" }
                            , Gordic.Gin.Globals.Enums.ModOtevreni.showModalWindow
                        );
                    }
                },
                actZverejneniHistorie6: {
                    name: "actZverejneniHistorie6",
                    caption: "Zveřejnění (showWindow)",
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        Gordic.Uda.Dialogs.ZverejneniSouboruHistorie(
                            that
                            , { Ixb: "DEMO0C011DM6" }
                            , Gordic.Gin.Globals.Enums.ModOtevreni.showWindow
                        );
                    }
                },
                //-----------------------------------------------------------------------------------------------------
                actJsonPropertySet: {
                    name: "actJsonPropertySet",
                    caption: "Json Property (set)",
                    icon: "",
                    run: function (ev, ctx) {
                        that.setJsonProperty(ev, ctx);
                    }
                },
                actJsonPropertyEmpty: {
                    name: "actJsonPropertyEmpty",
                    caption: "Json Property (empty)",
                    icon: "",
                    run: function (ev, ctx) {
                        that.emptyJsonProperty(ev, ctx);
                    }
                },
                actSessionSet: {
                    name: "actSessionSet",
                    caption: "Session (Set)",
                    icon: "",
                    run: function (ev, ctx) {
                        that.setSession(ev, ctx);
                    }
                },
                actSessionEmpty: {
                    name: "actSessionEmpty",
                    caption: "Session (empty)",
                    icon: "",
                    run: function (ev, ctx) {
                        that.emptySession(ev, ctx);
                    }
                },
                actLogNastaveni: {
                    name: "actLogNastaveni",
                    caption: "Log nastavení",
                    icon: "",
                    run: function (ev, ctx) {
                        that.logNastaveni(ev, ctx);
                    }
                },
                actVarLetTest: {
                    name: "actVarLetTest",
                    caption: "Var x Let",
                    icon: "",
                    run: function (ev, ctx) {
                        that.varLetTest(ev, ctx);
                    }
                }
            });

            this.menuBar(this.actions.createBar([
                ["Vyvěšení*", // main + sub
                    "actVyveseni1", "actVyveseni2", /*"actVyveseni3", "actVyveseni4",*/ "actVyveseni5", "actVyveseni6"
                ],
                ["Zveřejnění*", // main + sub
                    "actZverejneni1", "actZverejneni2", /*"actZverejneni3", "actZverejneni4",*/ "actZverejneni5", "actZverejneni6"
                ],
                ["Historie zveřejnění*", // main + sub
                    "actZverejneniHistorie1", "actZverejneniHistorie2", "actZverejneniHistorie3", "actZverejneniHistorie4", "actZverejneniHistorie5", "actZverejneniHistorie6"
                ],
                "actJsonPropertySet*",
                "actJsonPropertyEmpty*",
                "actSessionSet*",
                "actSessionEmpty*",
                "actLogNastaveni*",
                "actVarLetTest*"

            ])); // menuBar

            this.defaultForm = $("<div>")
                .appendTo(this.element)
                .gform("createFrom", new Gordic.Forms.Form({
                    name: "formTesty",
                    layoutDescriptor: "L1M1S1, breaks-200-500"
                })
                    .addRow("Ixp")
                    .addField("gstringbox", { name: "ixp", initialValue: "DEMOX0015BBE" })
                    .addRow("Název")
                    .addField("gstringbox", { name: "nazev", initialValue: "Toto je název" })
                    .addRow("Popis")
                    .addField("gstringbox", { name: "popis", initialValue: "A tohle je popis prosím" })
                    .addRow("Log")
                    .addField("gstringbox", { name: "log", rows: 15 })
                ); // gform


        } // onContentReady


        //-----------------------------------------------------------------------------------------------------
        /**
         * otevriVyveseni
         * 
         * @param {Gordic.Gin.Globals.Enums.ModOtevreni} mod
         */
        private otevriVyveseni(mod: Gordic.Gin.Globals.Enums.ModOtevreni | undefined) {

            let opt =  {
                Ixp: this.defaultForm!.findFields("ixp").gfield("getValue"),
                Ixb: undefined,
                Nazev: this.jsonProp ? this.jsonProp.nazev! : undefined,
                Popis: this.jsonProp ? this.jsonProp.popis! : undefined
            }

            Gordic.Uda.Dialogs.VyveseniNaUredniDesku(
                this
                , opt
                , mod
            );
        }

        //-----------------------------------------------------------------------------------------------------
        private setJsonProperty(ev, ctx): void {
            this.jsonProp = new Object();

            this.defaultForm!.findFields("nazev", "popis").gfield("model", "collect", this.jsonProp);

            this.logNastaveni(ev, ctx);
        } // setJsonProperty

        //-----------------------------------------------------------------------------------------------------
        private emptyJsonProperty(ev, ctx): void {
            this.jsonProp = undefined;

            this.logNastaveni(ev, ctx);

        } // emptyJsonProperty

        //-----------------------------------------------------------------------------------------------------
        private setSession(ev, ctx): void {
            let that = this;
            this.defaultForm!.findFields("nazev", "popis").gfield("model", "collect", this.model);

            this.call<void>("SetSession", { model: this.model })
                .done(function () {
                    that.logNastaveni(ev, ctx);
                })
                .fail(function (xhr, type, vobj) {
                    console.log("xhr, type, vobj", xhr, type, vobj);
                    alert("Došlo k chybě (viz log)");
                });

        } // setSession

        //-----------------------------------------------------------------------------------------------------
        private emptySession(ev, ctx): void {
            let that = this;
            this.call<void>("EmptySession")
                .done(function () {
                    that.logNastaveni(ev, ctx);
                })
                .fail(function (xhr, type, vobj) {
                    console.log("xhr, type, vobj", xhr, type, vobj);
                    alert("Došlo k chybě (viz log)");
                });
        } // emptySession

        //-----------------------------------------------------------------------------------------------------
        private logNastaveni(ev, ctx): void {
            let that = this;

            let log = "";

            log += "-- JsonProperty --" + "\n";

            if (this.jsonProp) {
                log += "nazev: " + this.jsonProp.nazev + "\n";
                log += "popis: " + this.jsonProp.popis + "\n";
            } else {
                log += "this.jsonProp:" + this.jsonProp + "\n";
            }

            log += "-- Session -- " + "\n"

            this.call<ObecneTestyDto>("GetSession")
                .done(function (vysl) {
                    if (vysl) {
                        log += "nazev:" + vysl.nazev + "\n";
                        log += "popis:" + vysl.popis + "\n";
                    } else {
                        log += "vysl:" + vysl + "\n";
                    }
                    that.defaultForm!.findFields("log").gfield("setValue", log);
                })
                .fail(function (xhr, type, vobj) {
                    console.log("xhr, type, vobj", xhr, type, vobj);
                    alert("Došlo k chybě (viz log)");
                });

        } // setJsonProperty

        //-----------------------------------------------------------------------------------------------------
        private varLetTest(ev, ctx): void {
            let prvni_v;
            prvni_v = "prvni var";
            if (true) {
                let druha_v;
                druha_v = "druha var"
                let druha_l;
                druha_l = "druha let"
            }
            //this.log(druha_v);
            //treti_v++;
            let treti_v;
            //this.log(treti_v); //NOTE: BMartinek 21.9.2018 - promenna log je na gcontentu pro logovani, pls. prejmenuj si metodu. Dik
            //this.log(druha_l);
        } // m

        //NOTE: BMartinek 21.9.2018 - promenna log je na gcontentu pro logovani, pls. prejmenuj si metodu. Dik
        //-----------------------------------------------------------------------------------------------------
        //private log(text: string) {
        //    let aText = this.defaultForm!.findFields("log").gfield("getValue");
        //    if (aText == null) {
        //        aText = "";
        //    }
        //    this.defaultForm!.findFields("log").gfield("setValue", aText + text + "\n");
        //} // m

    } // cls
} // ns